import React from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";
import ProjectGrid from "presentation/components/Project/ProjectGrid";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";

const ProjectGridPage = ({ children }: { children?: React.ReactNode }) => {
  const { isLoading } = usePermissionCheck({ requiredFunction: "projects" });

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <div>
      <FunctionHeader title="Projetos" />
      <ProjectGrid />
    </div>
  );
};

export default ProjectGridPage;
